export const GLAMPING_CATEGORIES = ['7', '13']

export function isGlamping(categories?: string[]) {
  return (
    !!categories &&
    categories.length === 2 &&
    categories.every((c) => GLAMPING_CATEGORIES.includes(c))
  )
}
